/**
 * GameStatus Component
 * 
 * Displays current game status including progress and win/loss messages.
 */

import React from 'react';
import { GameStatus as Status } from '@core/types';
import styles from './GameStatus.module.scss';

export interface GameStatusProps {
  status: Status;
  visitedCount: number;
  totalRooms: number;
}

export const GameStatus: React.FC<GameStatusProps> = ({ status, visitedCount, totalRooms }) => {
  const progress = Math.round((visitedCount / totalRooms) * 100);

  return (
    <div className={styles.gameStatus} role="status" aria-live="polite">
      <div className={styles.progress}>
        <span className={styles.label}>Progress:</span>
        <span className={styles.value}>
          {visitedCount} / {totalRooms} rooms ({progress}%)
        </span>
      </div>

      {status === 'won' && (
        <div className={styles.message} style={{ color: '#90ee90' }}>
          🎉 Congratulations! You escaped!
        </div>
      )}

      {status === 'lost' && (
        <div className={styles.message} style={{ color: '#ff6347' }}>
          😞 You're stuck! No available exits.
        </div>
      )}
    </div>
  );
};